export default function initRevealOnView() {
  if (window.IntersectionObserver) {
    const elements = document.querySelectorAll("[data-reveal-on-view]");
    const observer = new IntersectionObserver(onIntersection, {
      root: null, // default is the viewport
      threshold: 0.15, // percentage of target's visible area. Triggers "onIntersection"
    });

    // callback is called on intersection change
    // eslint-disable-next-line no-inner-declarations
    function onIntersection(entries, _opts) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add(
            entry.target.attributes["data-reveal-on-view"].value
          );
          entry.target.classList.remove("animate__initial");
          observer.unobserve(entry.target);
        }
      });
    }

    elements.forEach((element) => {
      // Use the observer to observe an element
      element.classList.add("animate__initial");
      observer.observe(element);
    });
  }
}
